<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 80vw">
      <div
        class="modal-header d-flex justify-content-between align-items-center"
      >
        <h5 class="modal-title">
          {{ isEdit ? "Edit Service" : "Create Service" }}
        </h5>
        <button
          type="button"
          class="close btn btn-danger btn-sm"
          @click="closeModal"
        >
          &times;
        </button>
      </div>

      <div class="modal-body">
        <form @submit.prevent="submitService">
          <!-- Row 1 -->
          <div class="row">
            <div class="form-group col-md-3">
              <label>Service Name</label>
              <input v-model="form.name" type="text" class="form-control" />
            </div>
            <div class="form-group col-md-3">
              <label>Insurance Price</label>
              <input
                v-model="form.insurance_price"
                type="number"
                class="form-control"
              />
            </div>
            <div class="form-group col-md-3">
              <label>Cash Price</label>
              <input
                v-model="form.cash_price"
                type="number"
                class="form-control"
              />
            </div>
            <div class="form-group col-md-3">
              <label>Invoice Price</label>
              <input
                v-model="form.invoice_price"
                type="number"
                class="form-control"
              />
            </div>
          </div>

          <!-- Row 2 -->
          <div class="row">
            <div class="form-group col-md-6">
              <label>Billing Area</label>
              <select v-model="form.billing_area_id" class="form-control">
                <option disabled value="">Select area</option>
                <!-- <option value="1">Consultation</option> -->
                <option value="2">Lab</option>
                <option value="3">Radiology</option>
                <option value="9">Nursing</option>
              </select>
            </div>

            <div class="form-group col-md-6 position-relative">
              <label>Category</label>
              <input
                v-model="categoryInput"
                @input="fetchCategorySuggestions"
                @focus="showSuggestions = true"
                @blur="handleBlur"
                type="text"
                class="form-control"
                placeholder="Type category"
              />
              <ul
                v-if="showSuggestions && filteredCategories.length"
                class="list-group position-absolute w-100 z-index-10"
              >
                <li
                  v-for="category in filteredCategories"
                  :key="category.id"
                  class="list-group-item list-group-item-action"
                  @mousedown.prevent="selectCategory(category)"
                >
                  {{ category.name }}
                </li>
              </ul>
            </div>
          </div>

          <!-- Row 3 -->
          <div class="row">
            <div class="form-group col-md-12">
              <label>Description</label>
              <textarea
                v-model="form.description"
                class="form-control"
                rows="2"
                placeholder="Enter description..."
              ></textarea>
            </div>
          </div>

          <!-- Submit -->
          <div class="d-flex justify-content-end mt-3">
            <button type="submit" class="btn btn-primary px-4">
              {{ isEdit ? "Update" : "Save" }} Service
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "@/api/apiIndex.js";

export default {
  name: "CreateServiceModal",
  props: {
    serviceToEdit: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        name: "",
        description: "",
        insurance_price: "",
        cash_price: "",
        invoice_price: "",
        billing_area_id: "",
        category_name: "",
      },
      categoryInput: "",
      showSuggestions: false,
      filteredCategories: [],
    };
  },
  computed: {
    isEdit() {
      return !!this.serviceToEdit;
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-create-service-modal");
    },
    selectCategory(category) {
      this.categoryInput = category.name;
      this.form.category_name = category.name;
      this.showSuggestions = false;
    },
    handleBlur() {
      setTimeout(() => {
        this.showSuggestions = false;
        if (
          !this.form.category_name ||
          this.categoryInput !== this.form.category_name
        ) {
          this.form.category_name = this.categoryInput;
        }
      }, 200);
    },
    async fetchCategorySuggestions() {
      const query = this.categoryInput.trim();
      // console.log(query);

      if (!query) return;

      const res = await generalApiRequest(
        "search-medical-service-categories",
        "GET",
        { name: query },
        1
      );
      console.log(res.data);

      this.filteredCategories = res.data || [];
      this.showSuggestions = true;
    },
    async submitService() {
      const endpoint = this.isEdit
        ? `update_medical_service/${this.serviceToEdit.id}`
        : "create_medical_service";
      const method = this.isEdit ? "POST" : "POST";

      const res = await generalApiRequest(endpoint, method, this.form, 1);
      this.$emit("service-created", res.data);
      this.closeModal();
    },
    populateForm() {
      if (this.serviceToEdit) {
        this.form = {
          ...this.form,
          name: this.serviceToEdit.name || "",
          description: this.serviceToEdit.description || "",
          insurance_price: this.serviceToEdit.insurance_charge || "",
          cash_price: this.serviceToEdit.cash_charge || "",
          invoice_price: this.serviceToEdit.invoice_charge || "",
          billing_area_id: this.serviceToEdit.billing_area_id || "",
          category_name: this.serviceToEdit.category_name || "",
        };
        this.categoryInput = this.serviceToEdit.category_name || "";
      }
    },
  },
  mounted() {
    this.populateForm();
  },
};
</script>

<style scoped>
ul.list-group {
  top: 100%;
  max-height: 200px;
  overflow-y: auto;
  z-index: 9999;
}
ul.list-group li {
  cursor: pointer;
}
</style>
